var _br;
import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalTitle } from 'reaxl';

/**
 * The Confirmation component will render the confirmation in an iframe if the url is passed. It will also render in a modal or static if the isModal is true
 */
import { jsx as _jsx, Fragment as _Fragment2, jsxs as _jsxs } from "react/jsx-runtime";
function Confirmation(_ref) {
  var _Fragment;
  let {
    text,
    onHide,
    isModal,
    confirmationMessage = 'Your Email has been sent.',
    dataCmp = 'emailConfirmation',
    title = 'Email Confirmation',
    size,
    ...rest
  } = _ref;
  const getConfirmationContent = () => /*#__PURE__*/_jsx("div", {
    className: "alert alert-success",
    children: /*#__PURE__*/_jsxs("div", {
      children: [confirmationMessage && (_Fragment || (_Fragment = /*#__PURE__*/_jsxs(_Fragment2, {
        children: [/*#__PURE__*/_jsx("strong", {
          children: confirmationMessage
        }), _br || (_br = /*#__PURE__*/_jsx("br", {}))]
      }))), text]
    })
  });
  const handleHide = data => {
    if (onHide) {
      onHide(data);
    }
  };
  if (isModal) {
    const bsSize = size ? 'sm' : 'large';
    return /*#__PURE__*/_jsxs(Modal, {
      show: true,
      onHide: handleHide,
      bsSize: bsSize,
      ...rest,
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        closeButton: true,
        children: /*#__PURE__*/_jsx(ModalTitle, {
          children: title
        })
      }), /*#__PURE__*/_jsx(ModalBody, {
        className: "clearfix",
        children: getConfirmationContent()
      })]
    });
  }
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": dataCmp,
    ...rest,
    children: getConfirmationContent()
  });
}
export default Confirmation;